import { JoiningProgress } from "@vivagym-joining/joining-progress";
import { ShoppingCart } from "@vivagym-joining/shopping-cart";

document.addEventListener("DOMContentLoaded", async () => {
	window.notificationsActive = true;
	window.loadMode = false;

	let subscriptionsData = null;
	let currentSelectedRadio = null;
	const vgApiClient = new VgApiClient(VgHelpers.getCountry(), VgHelpers.getLanguage());

	const vgForms = new VGForms();

	JoiningProgress.onDataReady(initStep);

	async function initStep(progress) {

		console.log("Loaded progress data:", progress);

		let countryPath = progress.getGymDomain();

		const step1resume = document.getElementById("step-1-resume");
		step1resume.style.display = "block";
		const quoteTable = document.querySelector(".vg-select-quote__table");
		const subscriptionSelection = document.querySelector(".vg-select-quote__list-detail");

		vgForms.addLoading(step1resume);
		vgForms.addLoading(quoteTable);
		vgForms.addLoading(subscriptionSelection);

		let gymId = progress.getGymId();

		subscriptionsData = await vgApiClient.getSubscriptions(gymId, progress.getGymCountry());

		if (subscriptionsData) {
			console.log("subscriptionsData:", subscriptionsData);

			initTable(gymId);
			addEventTooltipOnTable();
			addSwitchEvents();
			if (subscriptionsData.subscriptions) {
				renderSubscriptions(subscriptionsData, countryPath);
				addSubscriptionsExtras(subscriptionsData, countryPath);
			} else {
				new VgModal({
					title: JoiningVars.get_form_field("modals").joining_select_quote_intern.title,
					description: JoiningVars.get_form_field("modals").joining_select_quote_intern.content,
					data: [],
					type: "error",
					template: "basic",
				});
			}
			addFormEvents();
			checkFormSubmitButton();

			let preselectPopular = true;
			const urlParams = new URLSearchParams(window.location.search);
			const preselectedSubscription = urlParams.get('sub');
			if (preselectedSubscription) {
				const urlSubscription = selectSubscriptionByUrl(subscriptionsData, preselectedSubscription);

				if (urlSubscription) {
					const globalIdPreselected = urlSubscription.product.globalId;
					preSelectSubscriptionByUrl(globalIdPreselected);
					preselectPopular = false;
				}
			}

			if (preselectPopular) {
				const featuredSubscription = selectFeaturedSubscription(subscriptionsData);
				preSelectMostPopularSubscription(progress, featuredSubscription);
			}

			if (progress) {
				progress.stepData.forEach((step) => {

					if (step.step == progress.constSelectGymStep) {
						const step1SelectionResume =
							document.getElementById("step-1-resume");
						step1SelectionResume.innerHTML = step.data.name;
						vgForms.removeLoading(step1resume);
					}
					if (step.step == progress.constSelectQuote) {
						const userSubscriptions = step.data;
						deactiveNotifications();
						fillUserSubscriptions(userSubscriptions);
						activeNotifications();
						vgForms.removeLoading(quoteTable);
						vgForms.removeLoading(subscriptionSelection);
					}
				});
			}
			
		} else {
			console.error("Failed to fetch data.");
		}
	}

	function addEventTooltipOnTable() {
		handleTooltipEvents();
		window.addEventListener('resize', handleTooltipEvents);
	}

	function handleTooltipEvents() {
		document.addEventListener('vg-tooltip-hover', handleTooltipHover);
		document.addEventListener('vg-tooltip-click', handleTooltipClick);
	}

	function handleTooltipHover(event) {
		if (event.detail.content === undefined) {
			return;
		}
		event.detail.content.classList.toggle('hidden-tooltip', window.innerWidth < 801);
	}

	function handleTooltipClick(event) {
		if (event.detail.content === undefined) {
			return;
		}
		if (window.innerWidth > 801) {
			return;
		} 
		new VgModal({
			title: '',
			description: event.detail.content.innerHTML,
			data: [],
			type: 'tooltip-click',
			template: 'default',
		});
	}

	function fillUserSubscriptions(userSubscriptions) {
		Object.keys(userSubscriptions).forEach((key) => {
			userSubscriptions[key].forEach((item) => {
				const value = item["value"];
				const selectedElement = document.querySelector(
					`input[name="${key}"][value="${value}"]`
				);
				if (key === 'vg-select-quote--clipcard') { // If clipcard we need to click his checkbox acceptance
					let clipcardAcceptance = selectedElement?.parentElement.parentElement.querySelector('.vg-select-quote__clipcard-conditions input');
					clipcardAcceptance?.click();
				}
				selectedElement?.click();
			});
		});
	}

	function addSwitchEvents() {
		let currentlyChecked = null;
		const radios = document.querySelectorAll('[name="vg-select-quote--montly"]');
		radios.forEach( (r) => {
			if (r.checked) {
				currentlyChecked = r;
			}

			r.addEventListener("click", (e) => {
				// Skip if click comes from the label.
				if (e.explicitOriginalTarget !== e.originalTarget) return;
				if (currentlyChecked === e.target) {
					radios.forEach((ri) => {
						if (ri === e.target) {
							ri.checked = false;
						} else {
							ri.checked = true;
							currentlyChecked = ri;
							const trigger = new Event('change');
							ri.dispatchEvent(trigger);
						}
					})
					return;
				}
				currentlyChecked = e.target;
			});

			r.addEventListener("change", (event) => {
				let data = { selectedValue: event.target.value };
				document.dispatchEvent(
					new CustomEvent("switchMonthlyQuote", { detail: data })
				);
			});
		});
	}

	function addSubscriptionsEvents() {
		let subscriptionRadios = document.querySelectorAll(
			'input[name="vg-select-quote"]'
		);
		subscriptionRadios.forEach((radio) => {
			radio.addEventListener("click", (event) => {
				let data = {
					selectedKey: event.target.dataset.globalId,
					selectedName: event.target.dataset.webname,
					selectedValue: event.target.value,
				};

				if (currentSelectedRadio !== event.target) {
					if (currentSelectedRadio) {
						let previousData = {
							selectedKey: currentSelectedRadio.dataset.globalId,
							selectedName: currentSelectedRadio.dataset.webname,
							selectedValue: currentSelectedRadio.value,
						};
						let previousButtonLabel =
							currentSelectedRadio.nextElementSibling;

						previousButtonLabel.querySelector('.vg-select-quote__list-item-price-text').innerHTML =
							previousButtonLabel.dataset.textUnchecked;

						document.dispatchEvent(
							new CustomEvent("removeSubscription", {
								detail: previousData,
							})
						);
						//console.log("Event: removeSubscription", previousData);
					}

					currentSelectedRadio = event.target;

					document.dispatchEvent(
						new CustomEvent("addSubscription", { detail: data })
					);
					//console.log("Event: addSubscription", data);
				}
			});
		});
		subscriptionRadios.forEach((radio) => {
			const buttonQuote = radio.nextElementSibling;
			const buttonLabel = radio.nextElementSibling.querySelector('.vg-select-quote__list-item-price-text');

			radio.addEventListener("change", (event) => {
				if (event.target.checked) {
					buttonLabel.innerHTML = buttonQuote.dataset.textChecked;
				} else {
					buttonLabel.innerHTML = buttonQuote.dataset.textUnchecked;
				}
			});
			if (radio.checked) {
				buttonLabel.innerHTML = buttonQuote.dataset.textChecked;
			}
		});
	}

	function addSubscriptionsExtras(subscriptionsData, countryPath) {
		document.addEventListener("addSubscription", (event) => {
			const selectedSubscriptionGlobalId = event.detail.selectedKey;
			//console.log("selectedSubscription", selectedSubscriptionGlobalId);

			const subscriptionData = getSelectedSubscription(
				subscriptionsData,
				selectedSubscriptionGlobalId
			);
			if (subscriptionData) {
				updateCreationPrice(subscriptionData);
				updatePromotionBanner(subscriptionData);
			}

			renderAddons(subscriptionsData, selectedSubscriptionGlobalId);
			if (!dayPassGlobalId.includes(selectedSubscriptionGlobalId)) {
				renderClipcards(subscriptionsData, countryPath);
			} else {
				const clipcardsContainer = document.querySelector(
					".vg-select-quote__clipcard-list"
				);
				clipcardsContainer.innerHTML = "";
			}
		});
	}

	function getSelectedSubscription(subscriptionsData, globalId) {
		let subscription_selected = null;
		subscriptionsData.subscriptions.forEach((subscription) => {
			if (subscription.product.globalId === globalId) {
				subscription_selected = subscription;
			}
		});
		return subscription_selected;
	}

	function addAddonsEvents() {
		let addonsCheckboxes = document.querySelectorAll(
			'input[name="vg-select-quote--addons"]'
		);
		addonsCheckboxes.forEach((addon) => {
			addon.addEventListener("change", (event) => {
				let data = {
					selectedKey: event.target.dataset.globalId,
					selectedName: event.target.dataset.webname,
					selectedValue: event.target.value,
				};
				const buttonLabel = addon.nextElementSibling;
				if (event.target.checked) {
					buttonLabel.innerHTML = buttonLabel.dataset.textChecked;
					document.dispatchEvent(
						new CustomEvent("addAddon", { detail: data })
					);
					//console.log("Event: addAddon", data);
				} else {
					buttonLabel.innerHTML = buttonLabel.dataset.textUnchecked;
					document.dispatchEvent(
						new CustomEvent("removeAddon", { detail: data })
					);
					//console.log("Event: removeAddon", data);
				}
			});
		});
	}

	function addClipcardsEvents(countryPath) {

		const clipcards = document.querySelectorAll('.vg-select-quote__clipcard-item');

		clipcards.forEach((clipcard) => {
			const clipcardAcceptance  = clipcard.querySelector('.vg-select-quote__clipcard-conditions input');
			const clipcardButton      = clipcard.querySelector('.vg-select-quote__clipcard-button input');
			const clipcardButtonLabel = clipcard.querySelector('.vg-select-quote__clipcard-button label');

			clipcardAcceptance?.addEventListener("change", (event) => {
				clipcardButton.disabled = !clipcardAcceptance.checked;

				if (clipcardAcceptance.checked) {
					clipcardButtonLabel.removeAttribute("disabled");
				} else {
					clipcardButtonLabel.setAttribute("disabled", "true");
					clipcardButton.checked = false;
				}
			});

			clipcardButton?.addEventListener("change", (event) => {
				let data = {
					selectedKey: event.target.dataset.globalId,
					selectedName: event.target.dataset.webname,
					selectedValue: event.target.value,
				};

				if (clipcardButton.checked) {
					clipcardAcceptance.setAttribute("disabled", "true");
					clipcardButtonLabel.textContent = clipcardButtonLabel.getAttribute("data-text-checked");
					document.dispatchEvent(
						new CustomEvent("addClipcard", { detail: data })
					);
				} else {
					clipcardAcceptance.removeAttribute("disabled");
					clipcardButtonLabel.textContent = clipcardButtonLabel.getAttribute("data-text-unchecked");
					document.dispatchEvent(
						new CustomEvent("removeClipcard", { detail: data })
					);
				}
			});
		});
	}

	function uncheckAllSelectedClipcards( clipcards, event ) {
		clipcards?.forEach((clipcard) => {
			if (clipcard !== event?.target.parentElement.parentElement && clipcard.querySelector('.vg-select-quote__clipcard-button input').checked) {
				const clipcardButton = clipcard.querySelector('.vg-select-quote__clipcard-button input');
				const clipcardButtonLabel = clipcard.querySelector('.vg-select-quote__clipcard-button label');
				const clipcardAcceptance = clipcard.querySelector('.vg-select-quote__clipcard-conditions input');
				
				clipcardAcceptance.removeAttribute("disabled");
				clipcardButton.checked = false;
				clipcardButtonLabel.textContent = clipcardButtonLabel.getAttribute("data-text-unchecked");

				const data = {
					selectedKey: clipcardButton.dataset.globalId,
					selectedName: clipcardButton.dataset.webname,
					selectedValue: clipcardButton.value,
				};
				document.dispatchEvent(
					new CustomEvent("removeClipcard", { detail: data })
				);
			}
		});
	}

	function addFormEvents() {
		const formQuote = document.querySelector(".vg-select-quote__form");

		formQuote.addEventListener("submit", (event) => {
			event.preventDefault();

			const data = checkFormData(formQuote);

			document.dispatchEvent(
				new CustomEvent("formSubscriptionSubmit", { detail: data })
			);
		});

		formQuote.addEventListener("change", (event) => {
			// TODO: find a better way to skip fields
			if (event.target.name == "vg-select-quote--montly" || event.target.name == "vg-select-quote--weekly" || event.target.name.includes('vg-select-quote--clipcard-acceptance')) {
				return;
			}
			checkFormSubmitButton();

			const data = checkFormData(formQuote);

			document.dispatchEvent(
				new CustomEvent("formSubscriptionUpdated", { detail: data })
			);
		});
	}

	function checkFormData(formQuote) {
		const formData = new FormData(formQuote);
		const data = {};

		for (const [name, value] of formData) {
			if (name != "vg-select-quote--montly" && name != "vg-select-quote--weekly") {
				const inputElement = formQuote.querySelector(
					`input[name="${name}"][value="${value}"]`
				);
				const globalId = inputElement.dataset.globalId;
				const webname = inputElement.dataset.webname;
				const type = inputElement.dataset.type;
				if (!data[name]) {
					data[name] = [];
				}
				data[name].push({ value, webname, globalId, type });
			}
		}

		return data;
	}

	function checkFormSubmitButton() {
		const formQuote = document.querySelector(".vg-select-quote__form");
		const formData = new FormData(formQuote);
		const vgSelectQuoteSubmit = document.querySelector(
			".vg-select-quote__submit"
		);
		let selectedSubscription = false;
		for (const [name, value] of formData) {
			if (name == "vg-select-quote") {
				selectedSubscription = true;
			}
		}
		if (selectedSubscription) {
			vgSelectQuoteSubmit.disabled = false;
		} else {
			vgSelectQuoteSubmit.disabled = true;
		}
	}

	// Switch control for weekly/monthly prices
	document.addEventListener("switchMonthlyQuote", (event) => {
		if (event.detail.selectedValue == 0) {
			switchWeeklyPrice();
		} else {
			switchMonthlyPrice();
		}
	});

	function initTable(gymId) {
		const tableContainer = document.querySelector(".vg-select-quote__table");
		renderComparisionTable(gymId, tableContainer, subscriptionsData);
	}

	function formatGymsByZone(gymList) {

		let gymListFormatted = "<ul>";

		Object.entries(gymList).forEach(([region, gyms]) => {
			let regionElement = '<li>';
			regionElement += `<strong>${region}:</strong> `;
			gyms.forEach(gym => {
				regionElement += `${gym}, `;
			});
			regionElement = regionElement.slice(0, -2);
			regionElement += '</li>';

			gymListFormatted += regionElement;

		});

		gymListFormatted += "</ul>";

		return gymListFormatted;
	}

	function isOneFlexOrPrimeSubscription(subscriptionsData) {
		let hasOneFlexOrPrime = false;
		subscriptionsData.subscriptions.forEach((subscription) => {
			if (subOneFlexPrimeId.includes(subscription.product.globalId)) {
				hasOneFlexOrPrime = true;
			}
		});

		return hasOneFlexOrPrime;
	}

	async function renderComparisionTable(gymId, tableContainer, subscriptionsData) {

		const availableGymsForZone = await vgApiClient.getSubscriptionsGymsByRegion(gymId);
		const isOneFlexOrPrime = isOneFlexOrPrimeSubscription(subscriptionsData);

		const tableHead = document.createElement("thead");
		const tableRow = document.createElement("tr");
		const tableCol = document.createElement("th");
		tableRow.appendChild(tableCol);

		tableContainer.appendChild(tableHead);

		subscriptionsData.subscriptions?.forEach((subscription) => {
			if (!dayPassGlobalId.includes(subscription.product.globalId)) {

				// TODO: when webParking is available, use it instead name
				let subscriptionName = subscription.product.webname;
				subscriptionName = subscriptionName.replace("Cuota ", "").toLowerCase();

				const isMostPopular = subscription.product.mostPopular;
				const tableCol = document.createElement("th");
				tableCol.innerHTML =
				`
					<div class="${isMostPopular ? 'quote-featured' : ''}">
						<span>${subscriptionName.toUpperCase()}</span>
					</div>
				`;
				tableRow.appendChild(tableCol);
			}
		});

		tableHead.appendChild(tableRow);

		const tableBody = document.createElement("tbody");

		tableReference.forEach((row, index) => {

			const tableRow = document.createElement("tr");
			tableRow.classList.add("vg-table__item");
			tableRow.classList.add("border-line-top");
			const rowCol = document.createElement("td");
			rowCol.classList.add("vg-select-quote__quote-label");
			rowCol.classList.add("vg-table__cell-label");
			rowCol.innerHTML = row.label;

			if (isOneFlexOrPrime && row.label_2) {
				rowCol.innerHTML = row.label_2;
			}

			if (row['tooltip']) {

				let toolTipText = '';

				if (availableGymsForZone.error === null && !isOneFlexOrPrime) {
					if (availableGymsForZone.accessToAllGyms) {
						toolTipText = row['tooltip_1'];
					} else {
						toolTipText = row['tooltip_2'] + formatGymsByZone(availableGymsForZone.regions);
					}
				}

				if (isOneFlexOrPrime) {
					toolTipText = row['tooltip_3'];
				}

				rowCol.innerHTML +=
				`
				<vg-tooltip>
					<i class="icon icon--help-question vg-tooltip__trigger"></i>
					<div class="vg-tooltip__panel">${toolTipText}</div>
				</vg-tooltip>
				`;
			}

			tableRow.appendChild(rowCol);

			subscriptionsData.subscriptions?.forEach((subscription) => {
				if (!dayPassGlobalId.includes(subscription.product.globalId)) {

					const isMostPopular = subscription.product.mostPopular;
					const tableCol = document.createElement("td");
					tableCol.classList.add("vg-table__cell");

					if (isMostPopular) {
						tableCol.classList.add("quote-featured");
					}

					// TODO: when webParking is available, use it instead name
					let subscriptionName = subscription.product.webname;

					// TODO: general data should don't have this replace and not depend on the name (zone - club - iberia)!
					subscriptionName = subscriptionName.replace("Cuota ", "").toLowerCase();
					subscriptionName = subscriptionName.replace("corporate ", "");

					if (row[subscriptionName] === true) {
						tableCol.innerHTML = `<i class="icon icon--check"></i>`;
					} else {
						tableCol.innerHTML = row[subscriptionName] ?? "";

						if (row['key'] === 'gym-count') {
							tableCol.innerHTML = subscription.availableGyms;

							if (subOneId.includes(subscription.product.globalId)) {
								tableCol.innerHTML = '';
							}

							if (subFlexId.includes(subscription.product.globalId)) {
								tableCol.innerHTML = subscription.WEBGymIsNotInAGroupForFlex && subscription.WEBGymIsNotInAGroupForFlex == true ? `<i class="icon icon--check"></i>` : '';
							}

							if (subPrimeId.includes(subscription.product.globalId)) {
								tableCol.innerHTML = `<i class="icon icon--check"></i>`;
							}
						}

						if (row['key'] === 'water-price') {
							let addons = subscription.availableAddOnProducts;
							if (addons) {
								addons.forEach((addon) => {
									if (waterGlobalId.includes(addon.productGroupName)) {
										rowCol.innerHTML = rowCol.innerHTML.replace("[WATER]", addon.webname);
										tableCol.innerHTML = priceFormat(addon.normalPeriodPrice);
									}
								});
							}
						}

						if (row['key'] === 'parking') {
							if (subscription.parking) {
								tableCol.innerHTML = `<i class="icon icon--check"></i>`;

							}
						}

						if (row['key'] === 'baf') {
							if (subscription.BAF) {
								tableCol.innerHTML = `<i class="icon icon--check"></i>`;

							}
						}
					}
					tableRow.appendChild(tableCol);
				}
			});

			if (row['key'] === 'water-price' && !subscriptionsHasWaterAddon(subscriptionsData)) {
				tableRow.remove();
			} else {
				tableBody.appendChild(tableRow);
			}


		});
		tableContainer.appendChild(tableBody);
	}

	function subscriptionsHasWaterAddon(subscriptionsData) {
		let hasWaterAddon = false;
		subscriptionsData.subscriptions.forEach((subscription) => {
			if (subscription.availableAddOnProducts) {
				subscription.availableAddOnProducts.forEach((addon) => {
					if (waterGlobalId.includes(addon.productGroupName)) {
						hasWaterAddon = true;
					}
				});
			}
		});

		return hasWaterAddon;
	}

	function switchWeeklyPrice() {
		const subscriptions = document.querySelectorAll(
			".vg-select-quote__list-item"
		);
		const addons = document.querySelectorAll(
			".vg-select-quote__addons-price"
		);
		if (subscriptionsData.subscriptions) {
			subscriptions.forEach((subscription, index) => {
				if (!subscription.classList.contains("item-quote-special")) {
					// TODO: find better way to differentiate
					const row = subscription.querySelectorAll("[data-slot]");
					row.forEach((price) => {
						price.innerHTML = monthlyToWeeklyPrice(price.innerHTML);
					});
				}
			});
		}
		addons.forEach((addon, index) => {
			const row = addon.querySelectorAll("[data-slot]");
			row.forEach((price) => {
				price.innerHTML = monthlyToWeeklyPrice(price.innerHTML);
				price.nextElementSibling.innerHTML =
					price.dataset.priceWeekText;
			});
		});
	}

	function switchMonthlyPrice() {
		const subscriptions = document.querySelectorAll(
			".vg-select-quote__list-item"
		);
		const addons = document.querySelectorAll(
			".vg-select-quote__addons-price"
		);
		if (subscriptionsData.subscriptions) {
			subscriptions.forEach((subscription, index) => {
				if (!subscription.classList.contains("item-quote-special")) {
					// TODO: find better way to differentiate
					const row = subscription.querySelectorAll("[data-slot]");
					row.forEach((price) => {
						price.innerHTML = price.dataset.price;
					});
				}
			});
		}
		addons.forEach((addon, index) => {
			const row = addon.querySelectorAll("[data-slot]");
			row.forEach((price) => {
				price.innerHTML = price.dataset.price;
				price.nextElementSibling.innerHTML =
					price.dataset.priceMonthText;
			});
		});
	}

	function monthlyToWeeklyPrice(price) {
		let weeklyPrice = (parseFloat(price) * 12) / 52;
		let roundedPrice = weeklyPrice.toFixed(2);
		return roundedPrice.replace(".", ",");
	}

	function getTotalSubscriptions(subscriptionsData) {
		let total = 0;
		if (subscriptionsData.subscriptions) {
			subscriptionsData.subscriptions.forEach((subscription) => {
				if (!dayPassGlobalId.includes(subscription.product.globalId)) {
					total++;
				}
			});
		}
		return total;
	}

	function selectFeaturedSubscription(subscriptionsData) {
		let featured = null;
		if (subscriptionsData.subscriptions) {
			// Filter out the subscription with globalId: "DAYPASS"
			const filteredSubscriptions = subscriptionsData.subscriptions.filter(subscription => !dayPassGlobalId.includes(subscription.product.globalId));

			if (filteredSubscriptions.length === 1) {
				return filteredSubscriptions[0];
			}

			filteredSubscriptions.forEach((subscription) => {
				if (subscription.product.mostPopular) {
					featured = subscription;
				}
			});
		}
		return featured;
	}

	function selectSubscriptionByUrl(subscriptionsData, preselectedSubscription) {
		let featured = null;
		if (subscriptionsData.subscriptions) {
			subscriptionsData.subscriptions.forEach((subscription) => {
				if (subscription.product.globalId === preselectedSubscription){
					featured = subscription;
				}
			});
		}
		return featured;
	}

	function updateCreationPrice(subscription) {
		const registrationContainer = document.querySelector(
			".vg-select-quote__list-detail"
		);
		const registrationFee = registrationContainer.querySelector(
			".vg-select-quote__registration"
		);
		const registrationPrice = registrationFee.querySelector("[data-slot]");
		const registrationPricePromoted = registrationFee.querySelector(
			"[data-slot-promotion]"
		);
		const registrationPriceEnd =
			registrationFee.querySelector("[data-slot-end]");

		let isCreationPromoted = false;
		let isCreationPriceZero = false;

		if (subscription) {
			isCreationPromoted =
				subscription.creationPrice != subscription.creationNormalPrice
					? true
					: false;
			isCreationPriceZero =
				subscription.creationPrice == "0.00" ? true : false;

			registrationPrice.innerHTML = subscription.creationNormalPrice + "€";
		}

		if (isCreationPromoted) {
			registrationPrice.classList.add("vg-select-quote__underline-text");
		} else {
			registrationPrice.classList.remove(
				"vg-select-quote__underline-text"
			);
		}

		if (isCreationPriceZero) {
			registrationPriceEnd.classList.remove("disabled");
		} else {
			registrationPriceEnd.classList.add("disabled");
		}

		if (isCreationPromoted && !isCreationPriceZero) {
			registrationPricePromoted.innerHTML =
				subscription.creationPrice + "€";
		} else {
			registrationPricePromoted.innerHTML = "";
		}
	}

	function updatePromotionBanner(subscription) {
		const registrationContainer = document.querySelector(
			".vg-select-quote__list-detail"
		);
		const promotionBanner = registrationContainer.querySelector(
			".vg-select-quote__promotion"
		);
		const promotionText = promotionBanner.querySelector("[data-slot]");

		let isCreationPromoted = false;
		if (subscription) {
			isCreationPromoted =
				subscription.creationPrice != subscription.creationNormalPrice
					? true
					: false;
		}
		if (isCreationPromoted) {
			promotionBanner.classList.remove("disabled");
			promotionText.innerHTML = subscription.creationPriceText;
		} else {
			promotionBanner.classList.add("disabled");
		}
	}


	function preSelectSubscriptionByUrl(globalId) {
		const subPreselectedRadio = document.querySelector(
			`input[name="vg-select-quote"][data-global-id="${globalId}"]`
		);
		subPreselectedRadio.click();
	}

	function preSelectMostPopularSubscription(progress, subscription) {

		const data = progress.getSelectQuoteStep().data;
		const userHasSubscription = Object.keys(data).length > 0;

		if (subscription && !userHasSubscription) {
			const mostPopularRadio = document.querySelector(
				`input[name="vg-select-quote"][value="${subscription.productId.id}"]`
			);
			mostPopularRadio?.click();
		}
	}

	function renderSubscriptions(subscriptionsData, countryPath) {
		// Initially we show creation and promotion banner of the most popular subscription
		const featuredSubscription = selectFeaturedSubscription(subscriptionsData);
		updateCreationPrice(featuredSubscription);
		updatePromotionBanner(featuredSubscription);

		const quoteContainer = document.querySelector(".vg-select-quote__list");

		const promotionConditions = document.createElement("div");
		promotionConditions.classList.add(
			"vg-select-quote__promotion-conditions"
		);
		quoteContainer.appendChild(promotionConditions);

		let numQuotes = getTotalSubscriptions(subscriptionsData);
		quoteContainer.classList.add(`grid-${numQuotes}`);

		if (subscriptionsData.subscriptions) {
			subscriptionsData.subscriptions.forEach((subscription) => {
				const isDayPass =
					dayPassGlobalId.includes(subscription.product.globalId) ? true : false;
				const isMostPopular =
					subscription.product.mostPopular === true ? true : false;
				const isSubscriptionPromoted =
					subscription.proRataPrice &&
					subscription.proRataPrice == '0.00'
						? true
						: false;
				const isCreationPromoted =
					subscription.creationPrice != subscription.creationNormalPrice
						? true
						: false;

				const subscriptionElement = document.createElement("div");
				subscriptionElement.classList.add("vg-select-quote__list-item");

				if (isMostPopular) {
					subscriptionElement.classList.add("item-quote-featured");
				}

				if (isDayPass) {
					subscriptionElement.classList.add("item-quote-special");
				}

				// TODO: ensure that we want creationPriceSource or campaignSource
				let promotionConditionsContainer = document.querySelector(
					".vg-select-quote__promotion-conditions"
				);

				let promoCode = false;
				if (subscription.creationPriceSource) {
					let promoLink = JoiningVars.get_setting_field('vg_link_promo', countryPath, 'step-settings', 'settings');
					promotionConditionsContainer.innerHTML = `
						<div class="vg-select-quote__description-promotion">
							<p>${JoiningVars.get_form_field("promo-link-terms")}</p>
						</div>
					`;
					const linkConditions = promotionConditionsContainer.querySelector('a');
					linkConditions.setAttribute('id', 'vg-select-quote__promotions-link-conditions');
					linkConditions.setAttribute('target', '_blank');
					linkConditions.setAttribute('href', promoLink);
					promoCode = true;
				}

				let _text_extra = `
				${isDayPass ? `<p>${JoiningVars.get_form_field("pase-dia-texto")}</p>` : ""}`;

				subscriptionElement.innerHTML += `<div class="vg-select-quote__list-item-name">
				${promoCode && isDayPass ? promotionConditionsContainer : ""}
				<div class="vg-select-quote__list-item-label has-subtitle-s-font-size">
					${subscription.product.webname}
				</div>
				${
					isDayPass
						? `
					<div class="vg-select-quote__list-item-price has-h-3-font-size">
						<span data-price="${priceFormat(
							subscription.periodPrice
						)}" data-slot>${priceFormat(
							subscription.periodPrice
						)}</span><span>€</span>
					</div>`
						: ``
				}
				${_text_extra}
			</div>`;

				let btnText = isDayPass ? `${JoiningVars.get_form_field("quiero-seleccionar")} ${subscription.product.webname}` : `${JoiningVars.get_form_field("add-cuota")}`;
				let btnTextChecked = `${JoiningVars.get_form_field("added-cuota")}`;

				let priceQuoteElement = `<span class="vg-select-quote__list-item-price has-h-3-font-size${ isSubscriptionPromoted ? ' vg-select-quote__underline-text' : ''}">
											<span data-price="${priceFormat(
												subscription.periodPrice
											)}" data-slot>${priceFormat(
												subscription.periodPrice
											)}</span><span>€</span>
										</span>`;
				if( isDayPass ){
					priceQuoteElement = ``;
				}

				subscriptionElement.innerHTML += `
				<div class="vg-select-quote__list-item-button">
					<input type="radio"
							id="vg-select-quote--${subscription.product.webname}"
							name="vg-select-quote" value="${subscription.productId.id}"
							data-global-id="${subscription.product.globalId}"
							data-webname="${subscription.product.webname}"
							data-type="${subscription.product.type}"
							>
					<label for="vg-select-quote--${subscription.product.webname}"
							data-text-checked="${btnTextChecked}"
							data-text-unchecked="${btnText}"
							class="ob-button ob-button--secondary">
							<span class="vg-select-quote__list-item-price-text">${btnText}</span>
							${priceQuoteElement}

					</label>
				</div>
			`;

			quoteContainer.appendChild(subscriptionElement);
			});
		}
		addSubscriptionsEvents();
	}

	function renderAddons(subscriptionsData, quoteGlobalId) {
		const weeklyPrice = document.getElementById(
			"vg-select-quote--weekly"
		).checked;

		const addonsSection = document.querySelector(
			".vg-select-quote__addons"
		);
		addonsSection.innerHTML = "";

		const addonsContainer = document.createElement("div");
		addonsContainer.classList.add("vg-select-quote__container");
		addonsContainer.classList.add("vg-select-quote__addons-container");
		addonsSection.appendChild(addonsContainer);

		const title_addons = document.createElement("h2");
		title_addons.classList.add("vg-select-quote__addons-title");
		title_addons.classList.add("has-h-2-font-size");
		title_addons.innerHTML = addonsSection.dataset.title;
		addonsContainer.append(title_addons);

		const listAddonsContainer = document.createElement("div");
		listAddonsContainer.classList.add("vg-select-quote__addons-list");
		addonsContainer.appendChild(listAddonsContainer);

		subscriptionsData.subscriptions.forEach((subscription) => {
			if (
				subscription.product.globalId === quoteGlobalId &&
				!dayPassGlobalId.includes(subscription.product.globalId)
			) {
				if (!subscription.availableAddOnProducts) {
					return;
				}
				subscription.availableAddOnProducts.forEach((addon) => {
					const product = getProductFromCollectionByGlobalId(addon.productGroupName);

					const addonElement = document.createElement("div");
					addonElement.classList.add("vg-select-quote__addons-item");

					if (!product) { // TODO: remove this fallback when cpt is widelly used
						let addonImage = "demo-addons.svg";
						if (waterGlobalId.includes(addon.productGroupName)) {
							addonImage = "yanga-sport.webp";
						}
						if (lockerGlobalId.includes(addon.productGroupName)) {
							addonImage = "alquiler-taquilla.webp";
						}
						addonElement.innerHTML += `<img class="vg-select-quote__addons-image" src="/wp-content/plugins/vivagym-joining/steps/../assets/images/${addonImage}" alt="${addon.name}"></img>`;
					}

					if (product?.image_html) {
						const tempContainer = document.createElement('div');
						tempContainer.innerHTML = product.image_html;
						const imgElement = tempContainer.querySelector('img');
						imgElement.classList.add('vg-select-quote__addons-image');

						addonElement.appendChild(imgElement);
					}

					let str_price_month = JoiningVars.get_form_field("precio-mes");
					let str_price_week = JoiningVars.get_form_field("precio-semana");
					let str_add_to_quote = JoiningVars.get_form_field("add-mi-cuota");
					let str_remove_from_quote = JoiningVars.get_form_field("delete-mi-cuota");

					addonElement.innerHTML += `
					<div>
						<h3 class="vg-select-quote__addons-item-title">${product?.title || addon.webname}</h3>
						${product?.description || '<p>' + addon.description + '</p>'}
						<div class="vg-select-quote__addons-price has-h-3-font-size">
							<span data-price="${priceFormat(addon.normalPeriodPrice ?? addon.normalPrice)}"
							data-price-month-text="${str_price_month}"
							data-price-week-text="${str_price_week}"
							data-slot>${
						weeklyPrice === false
							? priceFormat(addon.normalPeriodPrice ?? addon.normalPrice)
							: priceFormat(
								monthlyToWeeklyPrice(addon.normalPeriodPrice ?? addon.normalPrice)
							)
					}</span>
							<span data-slot-text>${
						weeklyPrice === false
							? str_price_month
							: str_price_week
					}</span>
						</div>
					</div>
					`;

					addonElement.innerHTML += `
					<div class="vg-select-quote__addons-button">
						<input  type="checkbox"
								id="vg-select-quote--${addon.productGroupName}"
								name="vg-select-quote--addons"
								value="${addon.productId}"
								data-global-id="${addon.productGroupName}"
								data-webname="${addon.webname}"
								data-price-slot>
						<label  for="vg-select-quote--${addon.productGroupName}"
								class="ob-button ob-button--primary"
								data-text-unchecked="${str_add_to_quote}"
								data-text-checked="${str_remove_from_quote}"
								>
								${str_add_to_quote}
						</label>
					</div>
					`;

					listAddonsContainer.appendChild(addonElement);
				});
			}
		});
		addAddonsEvents();
	}

	function renderClipcards(subscriptionsData, countryPath) {
		const clipcardsContainer = document.querySelector(
			".vg-select-quote__clipcard-list"
		);
		clipcardsContainer.innerHTML = "";

		subscriptionsData.clipcards.forEach((clipcard) => {
			const product = getProductFromCollectionByGlobalId(clipcard.productGroupName);
			const addonElement = document.createElement("div");
			addonElement.classList.add("vg-select-quote__clipcard-item");

			if (!product) { // TODO: remove this fallback when cpt is widelly used
				addonElement.innerHTML += `<img class="vg-select-quote__clipcard-image" src="/wp-content/plugins/vivagym-joining/steps/../assets/images/one-experience.webp" alt="${clipcard.name}"></img>`;
			}

			if (product?.image_html) {
				const tempContainer = document.createElement('div');
				tempContainer.innerHTML = product.image_html;
				const imgElement = tempContainer.querySelector('img');
				imgElement.classList.add('vg-select-quote__clipcard-image');

				addonElement.appendChild(imgElement);
			}

			let str_add_to_quote = JoiningVars.get_form_field("comprar-mi-cuota");;
			let str_remove_from_quote = JoiningVars.get_form_field("delete-mi-cuota");;

			addonElement.innerHTML += `
			<div>
				<h3 class="vg-select-quote__clipcard-title has-h-3-font-size">${product?.title || clipcard.name}</h3>
				<div class="vg-select-quote__clipcard-description">
					${product?.description ||
					`<p>${JoiningVars.get_form_field("clipcard-parrafo")}</p>
					<ul>
						${JoiningVars.get_form_field("clipcard-lista").map((item) => `<li>${item}</li>`).join('')}
					</ul>`
					}
				</div>
				<div class="vg-select-quote__cilpcard-prices">
					<div class="vg-select-quote__cilpcard-price has-h-3-font-size">${priceFormat(clipcard.price)}€</div>
					<div class="vg-select-quote__cilpcard-price-promotion has-h-4-font-size vg-select-quote__underline-text">${priceFormat(clipcard.normalPrice)}€</div>
				</div>
			</div>
			`;

			addonElement.innerHTML += `
			<div class="vg-select-quote__clipcard-conditions vg-form__field-group-checkbox">
				<input  type="checkbox" id="vg-select-quote--clipcard-acceptance-${clipcard.productId.id}" name="vg-select-quote--clipcard-acceptance-${clipcard.productId.id}" value="clipcard-acceptance-${clipcard.productId.id}">
				<label for="vg-select-quote--clipcard-acceptance-${clipcard.productId.id}" class="vg-select-quote__clipcard-conditions-label">${product?.conditions || JoiningVars.get_form_field("clipcard-condiciones")}</label>
			</div>
			`;

			addonElement.innerHTML += `
			<div class="vg-select-quote__clipcard-button">
				<input type="checkbox"
				id="vg-select-clipcard-${clipcard.productId.id}"
				name="vg-select-quote--clipcard"
				value="${clipcard.productId.id}"
				data-global-id="${clipcard.productGroupName}"
				data-webname="${clipcard.webname}"
				disabled>
				<label for="vg-select-clipcard-${clipcard.productId.id}"
				class="ob-button ob-button--primary" disabled
				data-text-unchecked="${str_add_to_quote}"
				data-text-checked="${str_remove_from_quote}">
				${str_add_to_quote}
				</label>
			</div>
			`;

			clipcardsContainer.appendChild(addonElement);
			if (!product) { // TODO: remove this fallback when cpt is widelly used
				const clipcardAcceptance = addonElement.querySelector(".vg-select-quote__clipcard-conditions-label a");
				clipcardAcceptance?.setAttribute('href', JoiningVars.get_setting_field('vg_link_one_experience_terms', countryPath, 'step-settings', 'settings'));
			}
		});
		addClipcardsEvents(countryPath);
	}

	function getProductFromCollectionByGlobalId(globalId) {
		return productsCollection?.find(product => product.global_id.includes(globalId));
	}

	function activeNotifications() {
		window.notificationsActive = true;
		window.loadMode = false;
	}

	function deactiveNotifications() {
		window.notificationsActive = false;
		window.loadMode = true;
	}

	function priceFormat(price) {
		if (typeof price === "number" || !isNaN(price)) {
			price = parseFloat(price).toFixed(2);
		}

		if (typeof price !== "string") {
			price = price.toString();
		}

		return price.replace(".", ",");
	}

});
